import React, { useState } from "react";
import "./Pagination.scss";
export interface Props {
  itemPerPageProp: number;
  totalPagesProp: any;
  onPageChange: (page: number) => void;
  paginationFunction?: (page: number) => void;
}
const Pagination = ({
  itemPerPageProp,
  totalPagesProp,
  paginationFunction,
  onPageChange,
}: Props) => {
  const pageNumbers = [];
  let itemPerPage = itemPerPageProp;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalPagesProp / itemPerPage);
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    onPageChange(page);
    if (paginationFunction) {
      paginationFunction(page);
    }
  };

  return (
    <nav role="navigation" aria-label="Pagination Navigation">
      <ul className="mfg-pagination">
        <li className={`previous`}>
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1 ? true : false}
          >
            Prev
          </button>
        </li>
        {pageNumbers.map((number: number) => (
          <li key={number} className={currentPage === number ? "active" : ""}>
            <button
              onClick={() => {
                handlePageChange(number);
                if (paginationFunction) {
                  paginationFunction(number);
                }
              }}
              aria-current={currentPage === number ? "true" : "false"}
            >
              {number}
            </button>
          </li>
        ))}
        <li className={`next`}>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages ? true : false}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
